import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";
import { PAGE_SCHEMAS } from "./pageSchemas";

export default function PagesList() {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    api.get("/admin/pages").then(r => setPages(r.data));
  }, []);

  const byId = Object.fromEntries(pages.map(p => [p.slug, p]));

  return (
    <div data-testid="admin-pages-list">
      <p className="eyebrow">Content</p>
      <h1 className="mt-3 font-serif text-4xl text-jade font-light">Pages</h1>
      <p className="mt-3 text-ink/65 text-[14px] font-light max-w-2xl">
        Edit the copy that appears on the public site. Design and structure are kept in code; you control the words and per-page SEO.
      </p>

      <div className="mt-12 space-y-3">
        {Object.entries(PAGE_SCHEMAS).map(([slug, schema]) => {
          const p = byId[slug];
          const status = p?.status || "draft";
          const updated = p?.updated_at ? new Date(p.updated_at).toLocaleString() : "—";
          return (
            <Link
              key={slug}
              to={`/studio/pages/${slug}`}
              data-testid={`admin-page-${slug}`}
              className="flex items-center justify-between border border-mist px-6 py-5 hover:border-jade transition-colors group"
            >
              <div>
                <p className="font-serif text-xl text-jade">{schema.label}</p>
                <p className="text-[12px] text-ink/55 mt-1">Last updated {updated}</p>
              </div>
              <div className="flex items-center gap-6">
                <span
                  data-testid={`page-status-${slug}`}
                  className={`text-[10px] tracking-[0.18em] uppercase px-3 py-1 ${
                    status === "published" ? "bg-jade/10 text-jade" : "bg-copper/10 text-copper"
                  }`}
                >
                  {status}
                </span>
                <ArrowRight size={18} className="text-ink/40 group-hover:text-copper transition-colors" />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
